import { z } from 'zod';

import { ReplySettingsEnum } from '../../lib/validation/codecs';

import {
  ContextAnnotationSchema,
  ReferencedTweetSchema,
  TweetAttachmentsSchema,
  TweetAuthorAffiliationSchema,
  TweetAuthorSchema,
  TweetEntitiesSchema,
} from './entities';
import { MediaItemSchema, MediaMetadataEntrySchema } from './media';
import type { Tweet } from './tweet';

export const TweetSchema: z.ZodType<Tweet> = z.object({
  id: z.string(),
  text: z.string(),
  authorId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date().optional(),
  author: TweetAuthorSchema.optional(),
  conversationId: z.string().optional(),
  inReplyToUserId: z.string().optional(),
  lang: z.string().optional(),
  noteTweet: z
    .object({
      text: z.string(),
    })
    .optional(),
  likeCount: z.number().int().min(0),
  retweetCount: z.number().int().min(0),
  replyCount: z.number().int().min(0),
  quoteCount: z.number().int().min(0),
  entities: TweetEntitiesSchema.optional(),
  attachments: TweetAttachmentsSchema.optional(),
  mediaItems: z.array(MediaItemSchema).optional(),
  referencedTweets: z.array(ReferencedTweetSchema).optional(),
  authorAffiliations: z.array(TweetAuthorAffiliationSchema).optional(),
  authorPrimaryAffiliation: TweetAuthorAffiliationSchema.optional(),
  metadata: z.record(z.string(), z.any()).optional(),
  mediaMetadata: z.array(MediaMetadataEntrySchema).optional(),
  quotedTweet: z.lazy(() => TweetSchema).optional(),
  retweetedTweet: z.lazy(() => TweetSchema).optional(),
  isRetweet: z.boolean().optional(),
  isPinned: z.boolean().optional(),
  isLiked: z.boolean().optional(),
  isRetweeted: z.boolean().optional(),
  isLikedByUser: z.boolean().optional(),
  isBookmarked: z.boolean().optional(),
  relevanceScore: z.number().optional(),
  editHistoryTweetIds: z.array(z.string()).optional(),
  contextAnnotations: z.array(ContextAnnotationSchema).optional(),
  possiblySensitive: z.boolean().optional(),
  replySettings: ReplySettingsEnum.optional(),
});

export type TweetFromSchema = z.infer<typeof TweetSchema>;
